export enum ServiceDirection {
  arrival = 'arrival',
  departure = 'departure',
  transit = 'transit',
}

export enum ServiceType {
  premiumTransfer = 'Premium Transfer',
  vipLounge = 'VIP Lounge',
  fastTrack = 'Fast Track',
}

export class ServiceEl {
  id?: number;
  airportId?: number;

  serviceId?: number;
  cardId?: string;
  direction?: ServiceDirection;

  title: string = '';
  subtitle: string = '';
  types: ServiceType[] = [];
  description: string = '';
  imgUrl: string = '';
  inCart: boolean = false;

  price: number = 0;
  priceSubsequent: number = 0;
  quantity: number | null = 1;

  constructor(value: Partial<ServiceEl> = {}) {
    this.id = value.id;
    this.airportId = value.airportId;

    this.serviceId = value.serviceId;
    this.cardId = value.cardId;
    this.direction = value.direction;

    this.title = value.title ?? '';
    this.subtitle = value.subtitle ?? '';
    this.types = value.types ?? [];
    this.description = value.description ?? '';
    this.imgUrl = value.imgUrl ?? '';
    this.inCart = value.inCart ?? false;

    this.price = value.price ?? 0;
    this.priceSubsequent = value.priceSubsequent ?? 0;
    this.quantity = value.quantity ?? 1;
  }
}
